















































































































































































































































import Vue, { PropType } from "vue";
import _ from "lodash";

// Vuex
import { RootState } from "@/store";
import { mapGetters, mapState } from "vuex";

// Model
import { MODULE_COLORS } from "@/utility/Constants";
import { InstallationSecurityConfiguration } from "@/model/data/security/InstallationSecurityConfiguration";
import {
    EditInstallationSecurityConfigurationCommand,
    EditInstallationSecurityConfigurationReqData,
} from "@/model/communication/security/EditInstallationsSecurityConfigurationCommand";

import { Configuration } from "@/model/data/security/Configuration";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { ConfigurationSecurity } from "@/model/data/security/ConfigurationSecurity";
import { ImportTemplateReqData, ImportTemplateCommand } from "@/model/communication/security/ImportTemplateCommand";
import { ImportTemplateResData } from "@/model/communication/security/ImportTemplateResData";
import { TemplateContentEnum } from "@/model/data/enums/TemplateContentEnum";
import { ExportTemplateCommand, ExportTemplateReqData } from "@/model/communication/security/ExportTemplateCommand";
import { CReqExecutionResultEnum } from "@/model/communication/CReqExecutionResultEnum";
import { UpdateSecurityConfigurationNowCommand, UpdateSecurityConfigurationNowReqData } from "@/model/communication/security/UpdateSecurityConfigurationCommand";
import { GetImportableTemplateCommand, GetImportableTemplateReqData } from "@/model/communication/security/GetImportableTemplateCommand";
import { GetImportableTemplateResData } from "@/model/communication/security/GetImportableTemplateResData";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { RevertInstallationSecurityConfigurationCommand } from "@/model/communication/security/RevertInstallationSecurityConfigurationCommand";
import { RevertInstallationSecurityConfigurationResData } from "@/model/communication/security/RevertInstallationSecurityConfigurationResData";

//Components
import ActualConfigurationDialog from "./ActualConfigurationDialog.vue";
import ImportTemplateDialog from "./ImportTemplateDialog.vue";
import ExportTemplateDialog from "./ExportTemplateDialog.vue";
import AlarmsCard from "./AlarmsCard.vue";
import DelaysCard from "./DelaysCard.vue";
import TimeBandsCard from "./TimeBandsCard.vue";
import RevertConfigurationDialog from "./RevertConfigurationDialog.vue";

export default Vue.extend({
    components: {
        DelaysCard,
        ActualConfigurationDialog,
        ImportTemplateDialog,
        ExportTemplateDialog,
        AlarmsCard,
        TimeBandsCard,
        RevertConfigurationDialog,
    },
    data() {
        return {
            MODULE_COLORS,
            selectedTab: 0,
            reloadDelay: 0,
            editMode: false,
            showResetDialog: false,
            loading: false,
            loadingExport: false,
            showExportTemplateDialog: false,
            showImportTemplateDialog: false,
            showActualConfiguration: false,
            alertMessage: "",
            alertType: "",
            showAlert: false,
            importableTemplates: [],
            showForceDialog: false,
            loadingImport: false,
            canSave: false,
            canSaveDelays: false,
            canSaveAlarms: true,
            canSaveTimeBands: true,
            referenceConfiguration: null,
            showRevertDialog: false,
            loadingRevert: false,
        };
    },
    props: {
        installation: { required: true, type: Object as PropType<InstallationSecurityConfiguration> },
        loadingProp: Boolean,
    },
    watch: {
        installation: {
            handler() {
                if (this.installation.securityConfigurationReference) this.referenceConfiguration = this.installation.securityConfigurationReference.configuration;
                else if (this.installation.securityConfigurationActual) this.referenceConfiguration = this.installation.securityConfigurationActual.configuration;
                else this.referenceConfiguration = new Configuration();

                this.showAlert = false;
                this.editMode = false;
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        ...mapState({
            authUser: (state: RootState) => state.authMod.currentUser,
        }),

        ...mapGetters(["authUserHasPrivilege"]),

        delaysEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.ReadDelays);
        },
        alarmsEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.ReadAlarms);
        },
        timebandsEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.ReadBands);
        },
        canWriteDelays() {
            return this.authUserHasPrivilege(ClientPrivileges.WriteDelays);
        },
        canWriteAlarms() {
            return this.authUserHasPrivilege(ClientPrivileges.WriteAlarms);
        },
        canWriteTimeBands() {
            return this.authUserHasPrivilege(ClientPrivileges.WriteBands);
        },

        isDifferentFromDb() {
            if (this.actualConfiguration) return !this.actualConfiguration.isEqual(this.referenceConfiguration, true);
            return false;
        },

        actualConfiguration() {
            return this.installation.securityConfigurationActual ? this.installation.securityConfigurationActual.configuration : new Configuration();
        },
    },
    methods: {
        cancelConfiguration() {
            this.editMode = false;
            this.showResetDialog = false;
            if (this.$refs.delaysCard) this.$refs.delaysCard.resetConfiguration(this.referenceConfiguration);
            if (this.$refs.alarmsCard) this.$refs.alarmsCard.resetConfiguration(this.referenceConfiguration);
            if (this.$refs.timeBandsCard) this.$refs.timeBandsCard.resetConfiguration(this.referenceConfiguration);
        },
        async sendRequest(configuration: Configuration) {
            this.loading = true;
            try {
                let request = new EditInstallationSecurityConfigurationReqData();
                request.securityConfiguration = new ConfigurationSecurity();
                request.securityConfiguration.configuration = configuration;
                request.installationName = this.installation.name;
                request.editRools = false;

                let response: ApiGenericResponse = await new EditInstallationSecurityConfigurationCommand(request).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    if (response.message == CReqExecutionResultEnum.Ok) {
                        this.alertMessage = this.$t("security_management.savedCorrectly");
                        this.alertType = "success";
                        this.showAlert = true;
                        this.referenceConfiguration = configuration;
                    } else {
                        this.alertMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        this.showAlert = true;
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending EditInstallationSecurityConfiguration request ", e);
            }
            this.editMode = false;
            this.loading = false;
            this.$emit("reload-table");
        },

        async importConfiguration(templateId: number, templateName: string) {
            this.editMode = false;
            this.showImportTemplateDialog = false;
            this.loading = true;
            try {
                let request = new ImportTemplateReqData([this.installation.name], templateId);

                let response: ImportTemplateResData = await new ImportTemplateCommand(request).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    if (response.message == CReqExecutionResultEnum.Ok) {
                        this.alertMessage = this.$t("security_management.importedCorrectly", { templateName: templateName });
                        this.alertType = "success";
                        this.showAlert = true;
                        this.referenceConfiguration = response.referenceConfiguration.configuration;
                    } else {
                        this.alertMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        this.showAlert = true;
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending ImportTemplate request ", e);
            }
            this.loading = false;
        },
        async exportConfiguration(templateName: string, templateContent: TemplateContentEnum) {
            this.loadingExport = true;
            try {
                let request = new ExportTemplateReqData();
                request.installationName = this.installation.name;
                request.configurationToExport = this.referenceConfiguration;
                request.templateContent = templateContent;
                request.templateName = templateName;
                let response: ApiGenericResponse = await new ExportTemplateCommand(request).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    if (response.message == CReqExecutionResultEnum.Ok) {
                        this.alertMessage = this.$t("security_management.exportedCorrectly", { templateName: templateName });
                        this.alertType = "success";
                        this.showAlert = true;
                    } else {
                        this.alertMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        this.showAlert = true;
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending GetImportableTemplate request ", e);
            }
            this.loadingExport = false;
            this.showExportTemplateDialog = false;
        },
        async openImportConfigurationDialog() {
            this.showImportTemplateDialog = true;
            this.loadingImport = true;
            try {
                let request = new GetImportableTemplateReqData();
                request.installationName = this.installation.name;
                request.templateContent = TemplateContentEnum.Alarms | TemplateContentEnum.Delays | TemplateContentEnum.TimeBands;
                let response: GetImportableTemplateResData = await new GetImportableTemplateCommand(request).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.importableTemplates = response.importableTemplates;
                }
            } catch (e) {
                console.log("Something went wrong sending GetImportableTemplate request ", e);
            }
            this.loadingImport = false;
        },
        async forceUpdate() {
            this.showForceDialog = false;
            if (!this.isDifferentFromDb) return;
            try {
                let request = new UpdateSecurityConfigurationNowReqData();
                request.installationName = this.installation.name;

                let res: ApiGenericResponse = await new UpdateSecurityConfigurationNowCommand(request).execute();
                if (res.message) {
                    switch (res.message) {
                        case CReqExecutionResultEnum.Ok:
                            this.alertMessage = this.$t("security_management.commandSent");
                            this.alertType = "success";
                            this.showAlert = true;
                            break;
                        case CReqExecutionResultEnum.AgentOffline:
                            this.alertMessage = this.$t("security_management.agentOfflineForInstallation");
                            this.alertType = "warning";
                            this.showAlert = true;
                            break;
                        case CReqExecutionResultEnum.AgentNotInstalled:
                            this.alertMessage = this.$t("security_management.agentNotInstalled");
                            this.alertType = "error";
                            this.showAlert = true;
                            break;
                        case CReqExecutionResultEnum.DeviceLocked:
                            this.alertMessage = this.$t("security_management.agentLocked");
                            this.alertType = "warning";
                            this.showAlert = true;
                            break;
                        case CReqExecutionResultEnum.OperationNotAvailable:
                            this.alertMessage = this.$t("security_management.operationNotAvailable");
                            this.alertType = "info";
                            this.showAlert = true;
                            break;
                        case CReqExecutionResultEnum.FileNotFound:
                            this.alertMessage = this.$t("security_management.fileNotFound");
                            this.alertType = "error";
                            this.showAlert = true;
                            break;
                        case CReqExecutionResultEnum.ServerError:
                            this.alertMessage = this.$t("device_status.serverError");
                            this.alertType = "error";
                            this.showAlert = true;
                            break;
                        default:
                            break;
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending UpdateSecurityConfigurationNow request ", e);
            }
        },
        updateShowExportDialog(newVal: boolean) {
            this.showExportTemplateDialog = newVal;
        },
        calcCanSave(value, from) {
            if (from == "delays") this.canSaveDelays = value;
            else if (from == "alarms") this.canSaveAlarms = value;
            else if (from == "timebands") this.canSaveTimeBands = value;
            this.canSave = this.canSaveDelays && this.canSaveAlarms && this.canSaveTimeBands;
        },
        saveConfiguration() {
            this.editMode = false;
            let newConfiguration: Configuration = new Configuration();
            if (this.delaysEnabled && this.canWriteDelays) {
                if (this.$refs.delaysCard) {
                    let delaysLocalConfiguration: Configuration = this.$refs.delaysCard.saveConfiguration();
                    newConfiguration.delays = delaysLocalConfiguration.delays;
                } else newConfiguration.delays = this.referenceConfiguration.delays;
            }
            if (this.alarmsEnabled && this.canWriteAlarms) {
                if (this.$refs.alarmsCard) {
                    let alarmsLocalConfiguration: Configuration = this.$refs.alarmsCard.saveConfiguration();
                    newConfiguration.alarms = alarmsLocalConfiguration.alarms;
                } else newConfiguration.alarms = this.referenceConfiguration.alarms;
            }
            if (this.timebandsEnabled && this.canWriteTimeBands) {
                if (this.$refs.timeBandsCard) {
                    let timeBandsLocalConfiguration: Configuration = this.$refs.timeBandsCard.saveConfiguration();
                    newConfiguration.timeBands = timeBandsLocalConfiguration.timeBands;
                } else newConfiguration.timeBands = this.referenceConfiguration.timeBands;
            }
            newConfiguration.rollsConfig = this.referenceConfiguration.rollsConfig;
            this.sendRequest(newConfiguration);
        },
        async revertConfiguration() {
            this.loadingRevert = true;
            try {
                let response: RevertInstallationSecurityConfigurationResData = await new RevertInstallationSecurityConfigurationCommand(this.installation.name, false).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    if (response.message == CReqExecutionResultEnum.Ok) {
                        this.alertMessage = this.$t("security_management.revertedCorrectly");
                        this.alertType = "success";
                        this.showAlert = true;
                        this.referenceConfiguration = response.referenceConfiguration.configuration;
                        this.$emit("reload-table");
                    } else {
                        this.alertMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        this.showAlert = true;
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending RevertInstallationSecurityConfiguration request ", e);
            }
            this.loadingRevert = false;
            this.showRevertDialog = false;
        },
    },
});
